import axios from 'axios';
import base from '../config';
import { headers } from '../helper/api';

/**
 * Service for handling dynamic acknowledgement messages
 */
export class AcknowledgementService {

  /**
   * Determine acknowledgement ID based on order type and user role
   * @param {string} orderType - 'internal' or 'client'
   * @param {string} userRole - 'requester' or 'approver'
   * @returns {string} acknowledgement_id
   */
  static getAcknowledgementId(orderType, userRole) {
    const mapping = {
      'internal_requester': 'INTERNAL_ORDER_REQUESTER',
      'internal_approver': 'INTERNAL_ORDER_APPROVER',
      'client_requester': 'CLIENT_ORDER_REQUESTER',
      'client_approver': 'CLIENT_ORDER_APPROVER'
    };

    const key = `${orderType.toLowerCase()}_${userRole.toLowerCase()}`;
    return mapping[key] || 'INTERNAL_ORDER_REQUESTER'; // Default fallback
  }

  /**
   * Fetch acknowledgement message from API
   * @param {string} orderType - 'internal' or 'client'
   * @param {string} userRole - 'requester' or 'approver'
   * @returns {Promise<Object>} API response with acknowledgement data
   */
  static async getAcknowledgementMessage(orderType, userRole) {
    try {
      const acknowledgementId = this.getAcknowledgementId(orderType, userRole);

      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${base.urls.apis.details}/acknowledgement-messages?acknowledgement_id=${acknowledgementId}`,
        {
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data) {
        return {
          success: true,
          data: {
            acknowledgementId: response.data.acknowledgement_id,
            version: response.data.version,
            message: response.data.message,
            active: response.data.active
          }
        };
      } else {
        throw new Error('Invalid API response format');
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to load acknowledgement message'
      };
    }
  }
}

export default AcknowledgementService;